import { Comment } from './comment.model'
export class Section {
	constructor(
		public content: string,
		public name?: string,
		public subjectid?: number,
		public template_id?: number,
		public comments?: Comment[],
		public id?: number,
		public subjectparentid?: number
	) { }
}